<template>
  <AdminLayout>
    <template #content>
      <div class="d-flex justify-content-between align-items-start gap-3 mb-3">
        <div>
          <h1 class="h4 mb-1">Modifier le retour fournisseur</h1>
          <div v-if="supplierReturn" class="supplier-return-edit-meta d-flex flex-wrap align-items-center gap-2">
            <span class="badge" :class="statusClass(supplierReturn.status)">
              {{ statusLabel(supplierReturn.status) }}
            </span>
            <span class="supplier-return-edit-meta-item">
              <span class="text-muted">Date</span>
              <strong>{{ $format.date(supplierReturn.return_date) }}</strong>
            </span>
            <span class="supplier-return-edit-meta-item">
              <span class="text-muted">Référence</span>
              <strong>{{ supplierReturn.reference || '-' }}</strong>
            </span>
            <span class="supplier-return-edit-meta-item">
              <span class="text-muted">Fournisseur</span>
              <strong>{{ supplierReturn.supplier_name || '-' }}</strong>
            </span>
          </div>
        </div>

        <div class="d-flex flex-wrap justify-content-end gap-2">
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm btn-icon-label"
            title="Retour à la liste"
            @click="$router.push({ name: 'SupplierReturns' })"
          >
            <i class="fa fa-arrow-left"></i>
            <span class="btn-label ms-1">Retour à la liste</span>
          </button>

          <button
            v-if="supplierReturn"
            type="button"
            class="btn btn-outline-primary btn-sm btn-icon-label"
            title="Voir la fiche"
            @click="$router.push({ name: 'SupplierReturnShow', params: { id: supplierReturn.id } })"
          >
            <i class="fa fa-file-lines"></i>
            <span class="btn-label ms-1">Voir la fiche</span>
          </button>
        </div>
      </div>

      <div v-if="isLoading" class="text-center my-5">
        <i class="fa fa-spinner fa-spin fa-2x mb-2"></i>
        <div class="small text-muted">Chargement du retour fournisseur...</div>
      </div>

      <div v-else-if="errorMessage" class="alert alert-danger">
        {{ errorMessage }}
      </div>

      <div v-else-if="!supplierReturn" class="alert alert-warning">
        Retour fournisseur introuvable.
      </div>

      <div v-else-if="supplierReturn.status !== 'draft'" class="alert alert-warning">
        Seuls les retours fournisseur en brouillon peuvent être modifiés.
      </div>

      <div v-else class="card border-0 shadow-sm">
        <div class="card-body">
          <SupplierReturnForm
            mode="edit"
            :supplier-return="supplierReturn"
            :submitting="isSubmitting"
            @save="updateSupplierReturn"
            @cancel="$router.push({ name: 'SupplierReturnShow', params: { id: supplierReturn.id } })"
          />
        </div>
      </div>
    </template>
  </AdminLayout>
</template>

<script>
import SupplierReturnForm from './SupplierReturnForm.vue';

export default {
  name: 'SupplierReturnEditView',
  components: {
    SupplierReturnForm,
  },
  data() {
    return {
      supplierReturn: null,
      isLoading: false,
      isSubmitting: false,
      errorMessage: '',
    };
  },
  mounted() {
    this.fetchSupplierReturn();
  },
  methods: {
    async fetchSupplierReturn() {
      this.isLoading = true;
      this.errorMessage = '';
      this.supplierReturn = null;

      try {
        const response = await this.$api.get(`/supplier-returns/${this.$route.params.id}`);
        this.supplierReturn = response.data.data;
      } catch (error) {
        this.errorMessage = 'Impossible de charger le retour fournisseur.';
      } finally {
        this.isLoading = false;
      }
    },
    async updateSupplierReturn(payload) {
      if (!this.supplierReturn) return;

      this.isSubmitting = true;
      this.errorMessage = '';

      try {
        const response = await this.$api.put(`/supplier-returns/${this.supplierReturn.id}`, payload);
        const supplierReturn = response.data.data;
        this.$router.push({ name: 'SupplierReturnShow', params: { id: supplierReturn.id } });
      } catch (error) {
        this.errorMessage = this.extractErrorMessage(error, 'Impossible de modifier le retour fournisseur.');
      } finally {
        this.isSubmitting = false;
      }
    },
    extractErrorMessage(error, fallback) {
      if (error?.response?.data?.errors) {
        return Object.values(error.response.data.errors).flat().join(' ');
      }

      return fallback;
    },
    statusLabel(status) {
      return status === 'validated' ? 'Validé' : 'Brouillon';
    },
    statusClass(status) {
      return status === 'validated' ? 'bg-success' : 'bg-secondary';
    },
  },
};
</script>

<style scoped>
.supplier-return-edit-meta-item {
  align-items: center;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 0.375rem;
  display: inline-flex;
  gap: 0.5rem;
  min-height: 28px;
  padding: 0.25rem 0.6rem;
}
</style>
